<template>
  <b-row>
    <b-col class="col-lg-6 offset-lg-3 col-sm-12">
    <Modal autoShow="false" />
    <b-form @submit.stop.prevent="onSubmit">
      <div id="checkbox-container">
        <b-form-checkbox
          id="verify-checkbox"
          v-model="verify"
          name="verify-checkbox"
          value="accepted"
          size="lg"
          class="text-left"
          unchecked-value="not_accepted"
        >
          I declare under penalty of perjury that the requestor is the consumer whose personal information is the subject of the request
        </b-form-checkbox>
      </div>
      <br />
      <b-button
        type="submit"
        variant="primary"
        class="btn btn-lg btn-block"
        :disabled="verify === 'not_accepted'"
      >
        Submit
      </b-button>
    </b-form>
    </b-col>
  </b-row>
</template>
<script>
import Modal from '@/components/Modal.vue'

export default {
  components: { Modal },
  data () {
    return {
      verify: 'not_accepted'
    }
  },
  methods: {
    onSubmit () {
      if (this.verify === 'not_accepted') return false

      this.$store.dispatch('verifyAction', this.verify)
    }
  }
}
</script>
<style lang="less">
  #checkbox-container {
    margin: 0 auto;
    max-width: 460px
  }
</style>
